<template>
  <window title="Events">
    <vue-chart chart-type="BarChart" :chart-events="chartEvents"
    :columns="columns" :rows="rows" :options="options">
    </vue-chart>
  </window>
</template>


<script>
export default {
  data() {
    return {
      chartEvents: {
        select() {
        },
        ready() {
        },
      },
      columns: [{
        type: 'string',
        label: 'Year',
      }, {
        type: 'number',
        label: 'Sales',
      }, {
        type: 'number',
        label: 'Expenses',
      }],
      rows: [
        ['2004', 1000, 400],
        ['2005', 1170, 460],
        ['2006', 660, 1120],
        ['2007', 1030, 540],
      ],
      options: {
        title: 'Company Performance',
        hAxis: {
          title: 'Year',
          minValue: '2004',
          maxValue: '2007',
        },
        vAxis: {
          title: '',
          minValue: 300,
          maxValue: 1200,
        },
        width: '100%',
        height: 'auto',
        curveType: 'function',
      },
    };
  },
};
</script>
